<template>
  <div class="mt-6">
    <Pagination
      v-model="page"
      :per-page="hitsPerPage || 0"
      :records="nbHits || 0"
      :options="{
        template: shallowRef(CustomPagination),
        edgeNavigation: false,
        chunksNavigation: 'scroll',
        chunk: 3,
        hideCount: true,
      }"
      @paginate="paginate"
    ></Pagination>
  </div>
</template>

<script lang="ts" setup>
import Pagination from 'v-pagination-3'
import { useRouteQuery } from '@vueuse/router'
import CustomPagination from '../common/CustomPagination.vue'

const { nbHits, hitsPerPage, currentPage } = defineProps<{
  hitsPerPage?: number
  nbHits?: number
  nbPages?: number
  currentPage?: number
}>()
const emit = defineEmits(['updated'])

const pageQuery = useRouteQuery('page')

const page = ref(currentPage || Number(pageQuery.value) || 1)

// Flag to prevent emitting when updating programmatically
const isUpdatingProgrammatically = ref(false)

watch(
  () => currentPage || pageQuery.value,
  (value) => {
    isUpdatingProgrammatically.value = true
    page.value = currentPage || Number(value) || 1
    nextTick(() => {
      isUpdatingProgrammatically.value = false
    })
  }
)

function paginate(page: number) {
  // Only emit if not updating programmatically
  if (!isUpdatingProgrammatically.value) {
    emit('updated', page)
  }
}
</script>
<style scoped></style>
